exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".langs[data-v-10988cad]{position:relative}.langs .el-input[data-v-10988cad] input{min-height:36px}.tran[data-v-10988cad]{position:relative;height:50px}.tran .transData[data-v-10988cad]{position:absolute;z-index:4;right:56px}.lang[data-v-10988cad]{position:absolute;height:36px;padding:0 20px;border-left:0;background:#f5f7fa}\n", ""]);

// exports
